export default __webpack_public_path__ + "static/seaweed_map-492f7da6f31c5b2446611681d32c2916.jpg";